import { render, staticRenderFns } from "./ChannelsTabList.vue?vue&type=template&id=3bde9ce0"
import script from "./ChannelsTabList.vue?vue&type=script&lang=js"
export * from "./ChannelsTabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports